export default "__VITE_ASSET__Cv5zlJJP__"